<template>
    <div class="con">
        <div v-if="show2 == false">

            <div class="item flx alc">
                <div class="itemLeft">
                    头像修改
                </div>
                <div class="itemAva">
                    <img :src="$img(avatar)" alt="" />
                </div>

                <el-upload class="upload-demo" action="https://hrxsl.com/api/Common/oss_upload"
                    :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :headers="uploadHeaders"
                    :show-file-list="false">
                    <el-button type="primary">修改头像</el-button>
                </el-upload>



            </div>

            <div class="item flx alc">
                <div class="itemLeft">
                    昵称修改
                </div>
                <div class="itemMiddle">
                    <input type="text" :disabled="xiu" v-model="nickname" />
                </div>
                <el-button type="primary" @click="editnickanme" v-if="xiu == true">修改昵称</el-button>
                <el-button type="primary" @click="editnickanme1" v-else>完成</el-button>
            </div>

            <div class="item flx alc">
                <div class="itemLeft">
                    账号密码
                </div>
                <div class="itemMiddle">
                    如您需要更改当前账号密码，请点击【修改密码】
                </div>
                <el-button type="primary" @click="show1 = true">修改密码</el-button>
            </div>

            <div class="item flx alc">
                <div class="itemLeft">
                    账号注销
                </div>
                <div class="itemMiddle">
                    账号注销后，您的账号将会永久失效且不可恢复，视为自动放弃部分权限和服务。请谨慎操作！
                </div>
                <el-button type="primary" @click="show2 = true">注销账号</el-button>
            </div>

            <div class="item flx alc">
                <div class="itemLeft">
                    绑定手机
                </div>
                <div class="itemMiddle">
                    当前账号绑定手机号为: {{tel}}
                </div>
                <el-button type="primary" @click="show = true">修改手机</el-button>
            </div>

            <div class="item flx alc" @click="logout">
                <div class="itemLeft">
                    退出登录
                </div>
                <div class="itemMiddle">
                    退出当前登录账号
                </div>
                <el-button type="primary">退出账号</el-button>
            </div>
        </div>
        <!-- 修改手机号弹窗 -->
        <changePhone v-if="show" @cal="refreshInfo"></changePhone>
        <!-- 修改密码弹窗 -->
        <changePwd v-if="show1" @cal="refreshInfo"></changePwd>
        <!-- 注销账号弹窗 -->
        <delaccount v-if="show2" @col='show2 = false'></delaccount>
    </div>
</template>

<script>
    import {
        delAccount,
        shoUserInfo,
        shopedituser
    } from "@/api/index.js"
    import changePhone from "@/components/changePhoneNumber.vue"
    import changePwd from "@/components/changePwd.vue"
    import delaccount from "@/components/delaccount.vue"
    export default {
        components: {
            changePhone,
            changePwd,
            delaccount
        },
        data() {
            return {
                xiu:true,
                tel: "",
                show: false,
                show1: false,
                show2: false,
                nickname: "",
                avatar: "",
                uploadHeaders: {
                    token: localStorage.getItem('token'),
                    source: "pc"
                },
            }
        },
        created() {
            this.refreshInfo()
        },
        methods: {
            handleAvatarSuccess(e) {
                let that = this
                if (e.code == 1) {
                    that.editava(e.data.url)
                } else {
                    this.$message.error(e.data.msg)
                }
            },
            beforeAvatarUpload(file) {
                // 1. 允许的图片格式
                const allowType = ['image/png', 'image/jpg', 'image/jpeg']
                // 2. 最大8MB
                const maxSize = 8 * 1024 * 1024
            
                // 校验格式
                if (!allowType.includes(file.type)) {
                    this.$message.error('仅支持 png、jpg、jpeg 格式图片！')
                    return false
                }
            
                // 校验大小
                if (file.size > maxSize) {
                    this.$message.error('图片不能大于8MB！')
                    return false
                }
            
                // 校验通过，允许上传
                return true
            },
            editava(e){
                let that = this 
                let data = {}
                data.avatar = e
                shopedituser(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        that.avatar = e
                        that.$emit("rfh")
                    } else {
                        that.$message.error(res.msg)
                    }
                })
                console.log(e)
            },
            editnickanme1() {
                let that = this
                let data = {}
                data.nickname = that.nickname
                shopedituser(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        that.$emit("rfh")
                        that.xiu = true
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            editnickanme() {
                this.xiu = false
            },

            logout() {
                localStorage.removeItem('shop_token')
                window.location.href = "https://shop.hrxsl.com/"
            },
            hidePhone(phone) {
                if (!phone || phone.length !== 11) return phone;
                return phone.slice(0, 3) + '****' + phone.slice(7);
            },
            refreshInfo() {
                let that = this
                that.show = false
                that.show1 = false
                shoUserInfo().then((res) => {
                    if (res.code == 1) {
                        that.tel = that.hidePhone(res.data.tel)
                        that.nickname = res.data.nickname
                        that.avatar = res.data.avatar
                    } else {
                        that.$message.error(res.msg)
                        return
                    }
                })
            },
            delacc() {
                let that = this
                that.$confirm('确定要注销该账号吗?', '友情提醒 ', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delAccount().then((res) => {
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            localStorage.removeItem('token')
                            localStorage.removeItem('user_id')
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });
            },
        }
    }
</script>

<style scoped>
    .itemAva {
        width: 639px;
        height: 64px;
        text-align: left !important;
        margin-right: 30px;
        flex-shrink: 0;
    }

    .itemAva img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        object-fit: contain;
    }

    .item {
        margin-bottom: 24px;
    }

    .con {
        box-sizing: border-box;
        padding: 40px 30px;
    }

    .itemLeft {
        font-weight: 500;
        font-size: 14px;
        color: #3A3D4B;
        margin-right: 14px;
        flex-shrink: 0;
    }

    .itemMiddle {
        width: 639px;
        height: 42px;
        border-radius: 6px;
        border: 1px solid #D9D9D9;
        line-height: 42px;
        font-size: 14px;
        margin-right: 30px;
        text-align: left;
        box-sizing: border-box;
        padding: 0 12px;
    }

    .itemMiddle input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        background-color: transparent;
    }
</style>